
import { Vue } from "vue-class-component";

export default class ChevronDown extends Vue {}
